import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

// Use environment variable or empty string for relative path
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Reserved paths that should not be treated as tenant codes
const RESERVED_PATHS = [
  'login', 'forgot-password', 'reset-password', 'force-password-change',
  'public', 'admin-migration', 'diagnose-fees', 'admin', 'certificates',
  'dashboard', 'profile', 'superadmin', 'master-settings', 'consultants',
  'seat-booking', 'students', 'admission', 'fees', 'routine', 'attendance',
  'examination', 'hr', 'leave', 'library', 'inventory', 'hostel', 'transport',
  'accounts', 'reports', 'frontdesk', 'communication', 'transcripts', 'tickets',
  'roles', 'user-management', 'staff'
];

const TenantRedirect = () => {
  const { tenantCode } = useParams();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkAndRedirect();
  }, [tenantCode]);

  const checkAndRedirect = async () => {
    // If it's a reserved path, don't treat as tenant
    if (RESERVED_PATHS.includes(tenantCode.toLowerCase())) {
      setChecking(false);
      return;
    }
    
    // First check if tenant exists
    try {
      // Try with configured API URL first
      const response = await axios.get(`${API_URL}/api/tenants/by-subdomain/${tenantCode}`, {
        timeout: 5000 // 5 second timeout
      });
      
      if (response.data) {
        // Tenant exists, check if user is logged in for this tenant
        const token = localStorage.getItem('token');
        const storedTenantCode = localStorage.getItem('tenant_code');
        
        if (token && storedTenantCode === tenantCode) {
          // User is logged in, go to dashboard
          navigate(`/${tenantCode}/dashboard`, { replace: true });
        } else {
          // User not logged in, go to login
          navigate(`/${tenantCode}/login`, { replace: true });
        }
      } else {
        navigate(`/${tenantCode}/login`, { replace: true });
      }
    } catch (error) {
      console.error('Tenant check error:', error);
      // On any error, redirect to tenant login page
      // The login page will handle showing proper error message
      navigate(`/${tenantCode}/login`, { replace: true });
    }
    
    setChecking(false);
  };

  // If it's a reserved path, render nothing (let the main routes handle it)
  if (RESERVED_PATHS.includes(tenantCode?.toLowerCase())) {
    return null;
  }

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-gray-600">Redirecting...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default TenantRedirect;
